export const CUSTOM_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100, -1];

export const TABLE_ROWS_PER_PAGE_OPTIONS = [
  10,
  25,
  50,
  100,
  { value: -1, label: "All" },
];

export const ROWS_PER_PAGE_MENU_PROPS = {
  anchorOrigin: { vertical: "top", horizontal: "left" },
  transformOrigin: { vertical: "bottom", horizontal: "left" },
  marginThreshold: 16,
  PaperProps: {
    sx: {
      maxHeight: "min(320px, calc(100vh - 96px))",
    },
  },
};

export const getRowsPerPageLabel = (value) => (Number(value) === -1 ? "All" : String(value));

export const getTotalPagesForRows = (count, rowsPerPage) =>
  Number(rowsPerPage) === -1 ? 1 : Math.max(1, Math.ceil(count / rowsPerPage));

export const getPaginatedRows = (rows, page, rowsPerPage, zeroBased = false) => {
  if (Number(rowsPerPage) === -1) return rows;
  const start = (zeroBased ? page : page - 1) * rowsPerPage;
  return rows.slice(start, start + rowsPerPage);
};

export const getDisplayRange = (count, page, rowsPerPage, zeroBased = false) => {
  if (!count) return { from: 0, to: 0 };
  if (Number(rowsPerPage) === -1) return { from: 1, to: count };

  const start = (zeroBased ? page : page - 1) * rowsPerPage;
  return {
    from: start + 1,
    to: Math.min(start + rowsPerPage, count),
  };
};
